import DOMPurify from 'dompurify';

const HtmlRenderer = ({ htmlString }) => {
  const cleanHtml = DOMPurify.sanitize(htmlString);

  return (
    <div
      dangerouslySetInnerHTML={{ __html: cleanHtml }}
      className='[&>img]:py-4 [&>p]:py-2'
    />
  );
};

export default HtmlRenderer;
